<div class="header">
  <h3>{{ 'changePassword.profile' | translate }}</h3>
</div>

<div class="details-container">
  <div class="details-card">
    <div class="details-header">
      <h5>{{ 'changePassword.title' | translate }}</h5>
    </div>
    <form novalidate [formGroup]="changePasswordForm">
      <div class="input-container">
        <label for="currentPass">
          <span class="required">*</span> {{ 'changePassword.currentPassword' | translate }}
        </label>
        <input
          [type]="currPassFieldType"
          id="currentPass"
          placeholder="*********"
          formControlName="oldPassword"
        />
        <i
          class="bi"
          [ngClass]="
            currPassFieldType === 'password' ? 'bi-eye-slash hide-password' : 'bi-eye show-password'
          "
          (click)="onTogglePassword('currentPass')"
          tabindex="0"
          (keydown.enter)="onTogglePassword('currentPass')"
        ></i>
        <span class="error-text"
          ><img src="../../../../assets/images/Warning.svg" alt="warning icon" />{{
            changePasswordformErrors.oldPassword
          }}</span
        >
      </div>
      <div class="input-container">
        <label for="newPassword">
          <span class="required">*</span> {{ 'changePassword.newPassword' | translate }}
        </label>
        <input
          [type]="newPassFieldType"
          id="newPassword"
          placeholder="*********"
          formControlName="newPassword"
        />
        <i
          class="bi"
          [ngClass]="
            newPassFieldType === 'password' ? 'bi-eye-slash hide-password' : 'bi-eye show-password'
          "
          (click)="onTogglePassword('newPass')"
          tabindex="0"
          (keydown.enter)="onTogglePassword('newPass')"
        ></i>
        <span class="error-text"
          ><img src="../../../../assets/images/Warning.svg" alt="warning icon" />{{
            changePasswordformErrors.newPassword
          }}</span
        >
      </div>
      <div class="input-container">
        <label for="confirmPassword">
          <span class="required">*</span> {{ 'changePassword.confirmNewPassword' | translate }}
        </label>
        <input
          [type]="confirmPassFieldType"
          id="confirmPassword"
          placeholder="*********"
          formControlName="confirmPassword"
        />
        <i
          class="bi"
          [ngClass]="
            confirmPassFieldType === 'password'
              ? 'bi-eye-slash hide-password'
              : 'bi-eye show-password'
          "
          (click)="onTogglePassword('confirmPass')"
          tabindex="0"
          (keydown.enter)="onTogglePassword('confirmPass')"
        ></i>
        <span class="error-text"
          ><img src="../../../../assets/images/Warning.svg" alt="warning icon" />{{
            changePasswordformErrors.confirmPassword
          }}</span
        >
      </div>
      <ul>
        <li>
          <img src="../../../../assets/images/Warning.svg" alt="warning icon" />{{
            'changePassword.passwordRule1' | translate
          }}
        </li>
        <li>
          <img src="../../../../assets/images/Warning.svg" alt="warning icon" />{{
            'changePassword.passwordRule2' | translate
          }}
        </li>
        <li>
          <img src="../../../../assets/images/Warning.svg" alt="warning icon" />{{
            'changePassword.passwordRule3' | translate
          }}
        </li>
        <li>
          <img src="../../../../assets/images/Warning.svg" alt="warning icon" />{{
            'changePassword.passwordRule4' | translate
          }}
        </li>
        <li>
          <img src="../../../../assets/images/Warning.svg" alt="warning icon" />{{
            'changePassword.passwordRule5' | translate
          }}
        </li>
      </ul>
      <a
        class="button button-green"
        (click)="changePassword()"
        tabindex="0"
        (keydown.enter)="changePassword()"
      >
        <span>
          @if (isLoader()) {
            <span class="spinner-border spinner-border-sm"></span>
          }
          <span class="m-3">{{ 'changePassword.title' | translate }}</span>
        </span>
      </a>
    </form>
  </div>
</div>
